<template>

  <v-jumbotron>
    <v-container fill-height>
      <v-layout align-center>
        <v-flex>
          <h4 class="display-2 my-3">
            Verify your email to continue.
          </h4>
          </span>
          <span class="subheading">
            <p>Pleaes check your email for a verification link, then click it to verify your address. <br>
            You must verify your email address to fully activate your user account here. If you do not have access to the email account that was used to register this account, you will need to logout and create a new account using an email address that you can access.</p>
          </span>
          <v-divider class="my-3"></v-divider>
          <!-- <div class="title my-4">Confirm and continue</div> -->
          <!-- <v-btn :v-on:click="checkEmailVerificationState" large color="secondary" dark class="mx-0 my-3">Confim and continue</v-btn> -->

          <p v-if="!emailVerified" color="error">Your email is <strong>NOT</strong>  verified. Please check your email, click the link there, and then refresh this page to try again.</p>
          <p v-if="emailVerified">Email verified, thank you.</p>
          <v-btn v-if="emailVerified" to="/tour" class="mx-0" color="secondary">Confirm &amp; continue</v-btn>

        </v-flex>
      </v-layout>
    </v-container>
  </v-jumbotron>

</template>

<script>
  import firebase from 'firebase'

  export default {
    name: 'VerifyEmail',
    data () {
      return {
        // foo: 'bar'
        emailVerified: null,
        user: null

        // gradient: '315deg, #3f87a6, #f69d3c',
      }
    },
    created () {
      // console.log('Fetching token...')
      // console.log('Token: ', this.idToken)
      this.user = firebase.auth().currentUser
      this.emailVerified = firebase.auth().currentUser.emailVerified
      // console.log(this.user)
      // console.log(this.emailVerified)
    },
    mounted () {
      // console.log('VerifyEmail component mounted')
      // console.log(firebase.auth().currentUser)
      // console.log('emailVerified: ' + this.emailVerified)
    },
    // methods: {
    //   checkEmailVerification () {
    //     firebase.auth().currentUser.getIdToken(true) // force a user state refresh
    //     .then((idToken) => {
    //       this.$set(this.$data, 'emailVerified', firebase.auth().currentUser.emailVerified)
    //     })
    //     .then(this.$router.push('tour1'))
    //   }
    // },
    methods: {
      checkEmailVerificationState: () => {
        firebase.auth().currentUser.getIdToken(true) // force a token/user state refresh
        console.log('emailVerified (after token refresh): ' + this.emailVerified)
        .then((idToken) => {
          this.$set(this.$data, 'emailVerified', firebase.auth().currentUser.emailVerified)
          console.log('emailVerified (after check): ' + this.emailVerified)
        })
        .then(this.$router.push('tour1'))
      }
    }
    // computed: {
    //   emailVerified: () => {
    //     firebase.auth().currentUser.getIdToken(true)  // force a refresh
    //     console.log('emailVerified (after token refresh): ' + this.emailVerified)
    //     return firebase.auth().currentUser.emailVerified
    //   }
    // }
  }
</script>


// WEBPACK FOOTER //
// src/components/User/VerifyEmail.vue